(function(){
  "use strict";

  /* ---------- 0. Wortel, live-modus en assetkaart ---------- */
  var root = document.querySelector("[data-kv]") || document;
  var LIVE = root !== document && root.getAttribute("data-kv") === "live";
  var ASSETS = {};
  try { ASSETS = JSON.parse((root !== document && root.getAttribute("data-assets")) || "{}"); } catch(e){}
  function ASSET(p){ return ASSETS[p] || p; }
  var basisTitel = document.title;

  /* ---------- 0b. Films ---------- */
  var FILMS = [
  {
    "slug": "bladerhoopje-dat-wandelde",
    "titel": "Kameo en het bladerhoopje dat wandelde",
    "tekst": "Een hoopje herfstbladeren wandelt over het pad. Kameo en Milo volgen kleine sporen en ontdekken een egeltje dat bladeren voor zijn nest draagt.",
    "duur": "2 min 26 sec",
    "poster": "assets/video/poster-bladerhoopje-dat-wandelde.jpg",
    "video": "assets/video/bladerhoopje-dat-wandelde.webm",
    "alt": "Kameo en Milo kijken naar een bewegend bladerhoopje in het herfstbos",
    "leeftijd": "6 tot 8 jaar",
    "youtube": "akBRwiPjBvs"
  },
  {
    "slug": "schuivende-sinterklaaslaars",
    "titel": "Het raadsel van de schuivende Sinterklaaslaars",
    "tekst": "Op Sinterklaasavond schuift een laars over de veranda. Kameo en Milo vinden hoefsporen en ontdekken waarom pony Moos zo nieuwsgierig is.",
    "duur": "2 min 26 sec",
    "poster": "assets/video/poster-schuivende-sinterklaaslaars.jpg",
    "video": "assets/video/schuivende-sinterklaaslaars.webm",
    "alt": "Kameo en Milo kijken naar een schuivende rode Sinterklaaslaars op de veranda",
    "leeftijd": "6 tot 8 jaar",
    "youtube": "jJkM-QQvryA"
  },
  {
    "slug": "neus-van-de-sneeuwpop",
    "titel": "Wie pakte de neus van de sneeuwpop?",
    "tekst": "De wortelneus van de sneeuwpop is weg. Kameo en Milo zien oranje kruimels en kleine vogelsporen. Met een proef ontdekken ze wie honger had.",
    "duur": "2 min 26 sec",
    "poster": "assets/video/poster-neus-van-de-sneeuwpop.jpg",
    "video": "assets/video/neus-van-de-sneeuwpop.webm",
    "alt": "Kameo en Milo zien de lege neusplek van een sneeuwpop met blauwe sjaal",
    "leeftijd": "6 tot 8 jaar",
    "youtube": "sci8hvI2SX0"
  },
  {
    "slug": "waar-blijft-de-plof",
    "titel": "Waar blijft de plof?",
    "tekst": "Kameo en Milo zien veilig van binnen vuurwerk aan de overkant. Het licht is er al, maar de zachte plof komt later. Hoe kan dat?",
    "duur": "2 min 26 sec",
    "poster": "assets/video/poster-waar-blijft-de-plof.jpg",
    "video": "assets/video/waar-blijft-de-plof.webm",
    "alt": "Kameo en Milo zien vuurwerk door het slaapkamerraam en wachten op de plof",
    "leeftijd": "6 tot 8 jaar",
    "youtube": "gaB63bhXwSU"
  },
  {
    "slug": "reuzenschaduw",
    "titel": "Kameo en het raadsel van de reuzenschaduw",
    "tekst": "Milo logeert bij Kameo. Wie beweegt daar op de slaapkamermuur? Samen volgen ze het licht en ontdekken het antwoord.",
    "duur": "2 min 26 sec",
    "poster": "assets/video/poster-reuzenschaduw.jpg",
    "video": "assets/video/reuzenschaduw.webm",
    "alt": "Kameo en Milo kijken naar een enorme schaduw met konijnenoren op de slaapkamermuur",
    "leeftijd": "6 tot 8 jaar",
    "youtube": "nCmHxMN8Uxs"
  },
  {
    "slug": "spoor-van-lichtjes",
    "titel": "Het spoor van lichtjes",
    "tekst": "Een rij lichtjes lijkt door het gras te lopen. Kameo en Milo volgen het spoor, testen hun lantaarn en ontdekken vuurvliegjes die elkaar met licht vinden.",
    "duur": "2 min 28 sec",
    "poster": "assets/video/poster-spoor-van-lichtjes.jpg",
    "video": "assets/video/spoor-van-lichtjes-v2.webm",
    "alt": "Kameo en Milo volgen een rij gouden lichtjes door de nachtelijke weide",
    "youtube": "k9jYEnuYNCA"
  },
  {
    "slug": "konijntje-pippa",
    "titel": "Kameo en konijntje Pippa",
    "tekst": "Konijntje Pippa wil een rode appel uit de boom pakken. Met Kameo ontdekt ze een rustig pad over de heuvel. Daarna nemen ze de appel mee naar haar warme holletje.",
    "duur": "2 min 36 sec",
    "poster": "assets/video/poster-konijntje-pippa.jpg",
    "video": "assets/video/konijntje-pippa.webm",
    "alt": "Kameo en konijntje Pippa kijken naar een rode appel in de herfstboom",
    "youtube": "2j7U4E_5wCw"
  },
  {
    "slug": "pony-moos",
    "titel": "Kameo en pony Moos",
    "tekst": "Kameo mag voor het eerst op pony Moos rijden. Bij een smal bruggetje blijft Moos staan. Samen kiezen ze een rustig graspad naar de heuvel met vuurvliegjes.",
    "duur": "2 min 36 sec",
    "poster": "assets/video/poster-pony-moos.jpg",
    "video": "assets/video/pony-moos.webm",
    "alt": "Kameo zit op pony Moos op een heuvel tussen vuurvliegjes",
    "youtube": "GVY1FBrb2sA"
  },
  {
    "slug": "eenhoorn-lumi",
    "titel": "Kameo en de eenhoorn Lumi",
    "tekst": "Kameo ontmoet eenhoorn Lumi tussen de wolken. Een klein sterretje is zijn weg naar de hemel kwijt. Met licht in dauwdruppels helpen ze het stap voor stap terug.",
    "duur": "2 min 36 sec",
    "poster": "assets/video/poster-eenhoorn-lumi.jpg",
    "video": "assets/video/eenhoorn-lumi.webm",
    "alt": "Kameo en eenhoorn Lumi kijken naar een klein sterretje op de wolken",
    "youtube": "3lcjLVgqN_M"
  },
  {
    "slug": "bloemenbal",
    "titel": "Kameo en het bloemenbal",
    "tekst": "Kameo is uitgenodigd voor het bloemenbal van prinses Lila. Het sleuteltje van de muziekdoos is weg, totdat ze het bij een pioenroos ontdekken. Daarna kan de dans beginnen.",
    "duur": "2 min 36 sec",
    "poster": "assets/video/poster-bloemenbal.jpg",
    "video": "assets/video/bloemenbal.webm",
    "alt": "Kameo danst met muizenprinses Lila in een bloementuin",
    "youtube": "ACgboqpcyQM"
  },
  {
    "slug": "kussenraket",
    "titel": "De kussenraket",
    "tekst": "Kameo valt in slaap en droomt dat zijn kussen vliegt. Wolken veranderen van vorm, een verkeerde bocht zorgt voor een grap en uiteindelijk vindt hij zijn vertrouwde bed terug.",
    "duur": "2 min 6 sec",
    "poster": "assets/video/poster.jpg",
    "video": "assets/video/kussenraket.webm",
    "alt": "Kameo ligt lachend op zijn kussen",
    "youtube": "XpiBgJ0ZL9s"
  },
  {
    "slug": "walvis",
    "titel": "Kameo en de walvis die zijn liedje kwijt was",
    "tekst": "Kameo dobbert in een droom over de Paarse Zee. Een kleine walvis is het laatste stukje van zijn slaapliedje kwijt. Met het tikje van de boot, een plonsje en een schelp zoeken ze het samen terug.",
    "duur": "2 min 15 sec",
    "poster": "assets/video/poster-walvis.jpg",
    "video": "assets/video/walvis.webm",
    "alt": "Kameo zit in een houten bootje naast een kleine walvis op een paarse zee",
    "youtube": "DMizHbOS9rk"
  },
  {
    "slug": "dippie",
    "titel": "Kameo gaat logeren bij een dinosaurus",
    "tekst": "Kameo gaat logeren bij zijn vriendje Dippie, en bij Dippie is alles groot. Het bed lijkt een berg en het kussen is veel te dik. Dus bouwen ze samen een slaaptent onder het bed.",
    "duur": "2 min 16 sec",
    "poster": "assets/video/poster-dippie.jpg",
    "video": "assets/video/dippie.webm",
    "alt": "Kameo gluurt tussen de deken onder het bed, naast dinosaurus Dippie",
    "youtube": "2uM509DvlAA"
  },
  {
    "slug": "draaimolen",
    "titel": "Kameo en het laatste rondje van de draaimolen",
    "tekst": "De kermis gaat slapen, maar het paardje van de draaimolen wil nog één rondje. Kameo en een piepklein muisje rijden mee, steeds langzamer, tot de draaimolen zachtjes stilstaat.",
    "duur": "2 min 18 sec",
    "poster": "assets/video/poster-draaimolen.jpg",
    "video": "assets/video/draaimolen.webm",
    "alt": "Kameo rijdt op het houten paardje van de draaimolen met een slapend muisje voor zich",
    "youtube": "2HHMMRvg0S8"
  },
  {
    "slug": "maankamp",
    "titel": "Kameo kampeert op de maan",
    "tekst": "Kameo droomt dat hij met zijn robotvriendje op de maan kampeert. Daar wipt zijn slaapzak omhoog en zweeft knuffel Beer weg. Samen bedenken ze hoe alles op zijn plek blijft.",
    "duur": "2 min 17 sec",
    "poster": "assets/video/poster-maankamp.jpg",
    "video": "assets/video/maankamp.webm",
    "alt": "Kameo op de maan bij zijn tent, met zijn robotvriendje en een zwevende knuffelbeer",
    "youtube": "3bWfJUficEA"
  },
  {
    "slug": "dromenbakkerij",
    "titel": "Kameo en de dromenbakkerij",
    "tekst": "Kameo droomt van een bakkerij waar een kleine mol de dromen voor vannacht bakt. Na een flinke nies springen er drie droomkonijntjes uit de kom, en samen maken ze een weide om in te slapen.",
    "duur": "2 min 29 sec",
    "poster": "assets/video/poster-dromenbakkerij.jpg",
    "video": "assets/video/dromenbakkerij.webm",
    "alt": "Kameo in de dromenbakkerij bij een kom met een droomkonijntje, naast een mol met koksmuts",
    "youtube": "TWP827-sJ5c"
  },
  {
    "slug": "maan-in-de-plas",
    "titel": "De maan in de plas",
    "tekst": "Kameo denkt dat de maan in een plas is gevallen. Na een vinger, een blaadje en een natte neus ontdekt hij dat water werkt als een spiegel.",
    "duur": "2 min 6 sec",
    "poster": "assets/video/poster-maan-in-de-plas.jpg",
    "video": "assets/video/maan-in-de-plas.webm",
    "alt": "Kameo staat met een blaadje bij een plas waarin de maan weerspiegelt",
    "youtube": "mAwKd0Pd_m0"
  },
  {
    "slug": "tikkende-tentje",
    "titel": "Het tikkende tentje",
    "tekst": "Kameo logeert bij Bo in een tentje in de tuin van oma Egel. Het regent zacht op het doek, maar ergens tikt iets harder en Bo kan niet slapen. Samen luisteren ze net zolang tot ze weten waar dat tikje vandaan komt.",
    "duur": "2 min 18 sec",
    "poster": "assets/video/poster-tikkende-tentje.jpg",
    "video": "assets/video/tikkende-tentje.webm",
    "alt": "Kameo en egeltje Bo liggen onder hun dekens in een tentje, met een lantaarn erboven",
    "youtube": "0gw6yhw-Wuk"
  },
  {
    "slug": "fluistergrot",
    "titel": "De fluistergrot",
    "tekst": "Kameo en Milo horen een stem uit het nachtbos. Ze volgen het geluid over een beekje naar een grot, roepen er zelf iets in en ontdekken samen wat een echo is.",
    "duur": "2 min 20 sec",
    "poster": "assets/video/poster-fluistergrot.jpg",
    "video": "assets/video/fluistergrot.webm",
    "alt": "Kameo met een lantaarn en konijntje Milo bij de opening van een grot in het nachtbos",
    "youtube": ""
  },
  {
    "slug": "hoofd-dat-nog-speelt",
    "titel": "Het hoofd dat nog speelt",
    "tekst": "Milo logeert in een tentje. Zijn poten zijn moe, maar in zijn hoofd varen nog drie piratenschepen. Kameo laat zien dat een vertrouwd bedtijdritueel gewoon mee kan.",
    "duur": "2 min 11 sec",
    "poster": "assets/video/poster-hoofd-dat-nog-speelt.jpg",
    "video": "assets/video/hoofd-dat-nog-speelt.webm",
    "alt": "Kameo leest voor uit een boek in een tentje, naast konijntje Milo op een kussen",
    "youtube": "hLeAVOPK1ns"
  }
];
  var FILM = {};
  FILMS.forEach(function(f){ FILM[f.slug] = f; });

  /* ---------- 1. Hash-routing ---------- */
  var views = {};
  Array.prototype.forEach.call(root.querySelectorAll("[data-view]"), function(el){
    views[el.getAttribute("data-view")] = el;
  });

  function parseHash(){
    var h = (location.hash || "").replace(/^#\/?/, "");
    var anker = "";
    var i = h.indexOf("#");
    if (i !== -1){ anker = h.slice(i + 1); h = h.slice(0, i); }
    h = h.replace(/\/+$/, "");
    if (FILM[h]) return { view: "film", film: h, anker: anker };
    if (!views[h]) h = "home";
    return { view: h, film: null, anker: anker };
  }

  function stopMedia(){
    Array.prototype.forEach.call(root.querySelectorAll("video, audio"), function(m){
      if (!m.paused) { try { m.pause(); } catch(e){} }
    });
  }

  var PIJL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13m-5-6 6 6-6 6"/></svg>';

  function kaartVoor(f){
    return '<a class="kaart" href="#/' + f.slug + '">' +
      '<div class="kaart__beeld"><img src="' + ASSET(f.poster) + '" alt="' + f.alt + '" width="1280" height="720">' +
      '<div class="kaart__labels"><span class="badge badge--kijken">Kijken</span></div>' +
      '<span class="kaart__speel" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span></div>' +
      '<div class="kaart__body">' + (LIVE ? '' : '<span class="kaart__leeftijd" data-alleen-preview>' + (f.leeftijd || '2 tot 5 jaar') + '</span>') + '<h3>' + f.titel + '</h3>' +
      '<p class="kaart__tekst">' + f.tekst + '</p>' +
      '<div class="kaart__meta"><span>Tekenfilm · ' + f.duur + '</span><span class="kaart__meer">Bekijk ' + PIJL + '</span></div></div></a>';
  }

  var OVERZICHT = '<a class="kaart" href="#/#verhaaltjes">' +
    '<div class="kaart__beeld"><img src="' + ASSET("assets/serie/outro-referentie.jpg") + '" alt="Kameo ligt op een wolk met de tekst Slaap lekker" width="1280" height="720">' +
    '<div class="kaart__labels"><span class="badge badge--primair">Overzicht</span></div></div>' +
    '<div class="kaart__body">' + (LIVE ? '' : '<span class="kaart__leeftijd" data-alleen-preview>Alle leeftijden</span>') + '<h3>Terug naar alle verhaaltjes</h3>' +
    '<p class="kaart__tekst">Kijken, luisteren of voorlezen. Bekijk het hele overzicht en kies samen iets voor vanavond.</p>' +
    '<div class="kaart__meta"><span>Overzicht</span><span class="kaart__meer">Naar het overzicht ' + PIJL + '</span></div></div></a>';

  function vulFilm(f){
    Array.prototype.forEach.call(root.querySelectorAll("[data-film]"), function(el){
      var veld = el.getAttribute("data-film");
      if (f[veld] !== undefined) el.textContent = f[veld];
    });
    var video = document.getElementById("filmvideo");
    if (video){
      video.setAttribute("poster", ASSET(f.poster));
      video.innerHTML = '<source src="' + ASSET(f.video) + '" type="video/webm">Je browser kan deze video niet afspelen.';
      video.load();
    }
    var i = FILMS.indexOf(f);
    var volgende = FILMS[(i + 1) % FILMS.length];
    var bak = document.getElementById("filmvolgend");
    if (bak) bak.innerHTML = kaartVoor(volgende) + OVERZICHT;
    var yt = document.getElementById("filmyoutube");
    var noot = document.getElementById("filmyoutubenoot");
    var nootlink = document.getElementById("filmyoutubelink");
    var adres = f.youtube ? "https://www.youtube.com/watch?v=" + f.youtube : "";
    if (yt){
      if (adres) yt.href = adres;
      yt.hidden = !adres;
    }
    if (noot) noot.hidden = !adres;
    if (nootlink && adres) nootlink.href = adres;
  }

  var huidig = null;
  var huidigeFilm = null;
  function route(scroll){
    var r = parseHash();
    if (r.view !== huidig || r.film !== huidigeFilm){
      stopMedia();
      if (r.film) vulFilm(FILM[r.film]);
      Object.keys(views).forEach(function(k){ views[k].hidden = (k !== r.view); });
      huidig = r.view;
      huidigeFilm = r.film;
      document.title = r.film ? FILM[r.film].titel + ", Slaapverhaaltjes van Kameo"
                     : r.view === "kussen-kwijt" ? "Kameo is zijn kussen kwijt, Slaapverhaaltjes van Kameo"
                     : r.view === "kleurplaten" ? "Kleurplaten van Kameo om te printen"
                     : basisTitel;
    }
    if (scroll === false) return;
    if (r.anker){
      var doel = document.getElementById(r.anker);
      if (doel){ doel.scrollIntoView({ behavior: "auto", block: "start" }); return; }
    }
    window.scrollTo(0, 0);
  }

  window.addEventListener("hashchange", function(){ route(true); });
  route(false);
  if (!location.hash) { window.scrollTo(0, 0); }

  /* interne ankers binnen de hub */
  Array.prototype.forEach.call(root.querySelectorAll('a[href^="#verhaaltjes"], a[href^="#voor-ouders"], a[href^="#kleurplaten"]'), function(a){
    a.addEventListener("click", function(e){
      var doel = document.getElementById(a.getAttribute("href").slice(1));
      if (doel){ e.preventDefault(); doel.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  });

  /* ---------- 2. Filterbalk ---------- */
  var filters = root.querySelectorAll(".filter");
  var kaarten = root.querySelectorAll("#kaartgrid [data-format]");
  var leeg = document.getElementById("geenresultaat");

  Array.prototype.forEach.call(filters, function(knop){
    knop.addEventListener("click", function(){
      var kies = knop.getAttribute("data-filter");
      Array.prototype.forEach.call(filters, function(k){
        k.setAttribute("aria-pressed", String(k === knop));
      });
      var zichtbaar = 0;
      Array.prototype.forEach.call(kaarten, function(kaart){
        var toon = (kies === "alles") || (kaart.getAttribute("data-format") === kies);
        kaart.hidden = !toon;
        if (toon) zichtbaar++;
      });
      if (leeg) leeg.hidden = zichtbaar > 0;
    });
  });

  /* ---------- 3. Paginaviewer ---------- */
  var rollen = {
    1: "Omslag", 2: "Opdracht", 3: "Titelpagina",
    14: "Colofon", 15: "Sfeerpagina", 16: "Achterkant"
  };
  function rolVan(n){ return rollen[n] || ("Bladzijde " + (n - 3)); }

  var totaal = 16;
  var nu = 1;
  var bladbeeld = document.getElementById("bladbeeld");
  var paginanu  = document.getElementById("paginanu");
  var paginarol = document.getElementById("paginarol");
  var duimenbak = document.getElementById("duimen");
  var vorige    = document.getElementById("vorige");
  var volgende  = document.getElementById("volgende");

  function pad(n){ return (n < 10 ? "0" : "") + n; }
  function bron(n){ return ASSET("assets/boek/pagina-" + pad(n) + ".jpg"); }

  if (bladbeeld && duimenbak){
    for (var i = 1; i <= totaal; i++){
      (function(n){
        var b = document.createElement("button");
        b.type = "button";
        b.className = "duim";
        b.setAttribute("role", "tab");
        b.setAttribute("aria-label", "Pagina " + n + ", " + rolVan(n));
        b.setAttribute("aria-current", n === 1 ? "true" : "false");
        var img = document.createElement("img");
        img.src = bron(n);
        img.alt = "";
        img.loading = "lazy";
        b.appendChild(img);
        b.addEventListener("click", function(){ toon(n); });
        duimenbak.appendChild(b);
      })(i);
    }

    var duimen = duimenbak.querySelectorAll(".duim");

    function toon(n){
      nu = Math.min(totaal, Math.max(1, n));
      bladbeeld.src = bron(nu);
      bladbeeld.alt = "Pagina " + nu + " van Kameo is zijn kussen kwijt, " + rolVan(nu);
      paginanu.textContent = String(nu);
      paginarol.textContent = rolVan(nu);
      vorige.disabled = (nu === 1);
      volgende.disabled = (nu === totaal);
      Array.prototype.forEach.call(duimen, function(d, idx){
        d.setAttribute("aria-current", String(idx + 1 === nu));
      });
      var actief = duimen[nu - 1];
      if (actief && actief.scrollIntoView){
        actief.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    }

    vorige.addEventListener("click", function(){ toon(nu - 1); });
    volgende.addEventListener("click", function(){ toon(nu + 1); });

    document.addEventListener("keydown", function(e){
      if (huidig !== "kussen-kwijt") return;
      var t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA")) return;
      if (e.key === "ArrowLeft"){ toon(nu - 1); }
      if (e.key === "ArrowRight"){ toon(nu + 1); }
    });

    toon(1);
  }

  /* ---------- 4. Conceptknoppen en conceptformulier ---------- */
  function melding(el, tekst){
    var m = el.parentNode.querySelector("[data-melding]");
    if (!m){
      m = document.createElement("span");
      m.setAttribute("data-melding", "1");
      m.className = "conceptnoot";
      m.style.flex = "1 1 100%";
      el.parentNode.appendChild(m);
    }
    m.textContent = tekst;
  }

  Array.prototype.forEach.call(root.querySelectorAll("[data-concept]"), function(knop){
    knop.addEventListener("click", function(){
      melding(knop, "Dit is een conceptpreview, deze knop doet nog niets.");
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll("[data-concept-form]"), function(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var noot = form.parentNode.querySelector(".formnoot");
      if (noot) noot.textContent = "Dit formulier verstuurt nog niets, het hoort bij de conceptpreview.";
    });
  });

  /* ---------- 4b. Eén verhaal tegelijk ---------- */
  root.addEventListener("play", function(e){
    Array.prototype.forEach.call(root.querySelectorAll("audio, video"), function(m){
      if (m !== e.target && !m.paused) { try { m.pause(); } catch(err){} }
    });
  }, true);

  /* ---------- 4c. Kleurplaten: filter en paginering ---------- */
  (function(){
    var sectie = root.querySelector("#kleurplaten");
    if (!sectie || !sectie.querySelector("#kp-vellen")) return;
    var vellen = Array.prototype.slice.call(sectie.querySelectorAll(".vel[data-niveau]"));
    var knoppen = Array.prototype.slice.call(sectie.querySelectorAll("[data-kp-filter]"));
    var pag = sectie.querySelector("#kp-pag");
    var telling = sectie.querySelector("#kp-telling");
    var alle = sectie.querySelector("#kp-alle");
    var uitleg = sectie.querySelector("#kp-uitleg");
    var balk = sectie.querySelector(".kpbalk");
    var bak = sectie.querySelector("#kp-vellen");
    var PER = 10, filter = "alles", pagina = 1;

    function maak(label, doel, uit, huidig, aria){
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = label;
      b.setAttribute("aria-label", aria);
      if (uit) b.disabled = true;
      if (huidig) b.setAttribute("aria-current", "page");
      b.addEventListener("click", function(){ pagina = doel; toon(true); });
      return b;
    }

    function toon(scrollen){
      var zicht = vellen.filter(function(v){ return filter === "alles" || v.getAttribute("data-niveau") === filter; });
      var paginas = Math.max(1, Math.ceil(zicht.length / PER));
      pagina = Math.min(Math.max(1, pagina), paginas);
      var start = (pagina - 1) * PER;
      vellen.forEach(function(v){ v.hidden = true; });
      zicht.slice(start, start + PER).forEach(function(v){ v.hidden = false; });
      pag.innerHTML = "";
      pag.hidden = paginas < 2;
      if (paginas > 1){
        pag.appendChild(maak("Vorige", pagina - 1, pagina === 1, false, "Vorige pagina"));
        for (var i = 1; i <= paginas; i++){ pag.appendChild(maak(String(i), i, false, i === pagina, "Pagina " + i)); }
        pag.appendChild(maak("Volgende", pagina + 1, pagina === paginas, false, "Volgende pagina"));
      }
      telling.textContent = zicht.length ? ("Kleurplaat " + (start + 1) + " tot " + Math.min(start + PER, zicht.length) + " van " + zicht.length) : "";
      if (bak) bak.scrollLeft = 0;
      if (scrollen && balk && balk.getBoundingClientRect().top < 0){ balk.scrollIntoView({ block: "start" }); }
    }

    knoppen.forEach(function(k){
      k.addEventListener("click", function(){
        filter = k.getAttribute("data-kp-filter");
        pagina = 1;
        knoppen.forEach(function(x){ x.setAttribute("aria-pressed", String(x === k)); });
        var bundel = k.getAttribute("data-pdf");
        alle.hidden = !bundel;
        if (bundel){
          alle.setAttribute("href", ASSET(bundel));
          alle.querySelector("[data-kp-label]").textContent = k.getAttribute("data-label");
          alle.querySelector("[data-kp-grootte]").textContent = k.getAttribute("data-grootte");
        }
        uitleg.textContent = k.getAttribute("data-uitleg");
        toon(false);
      });
    });
    toon(false);
  })();

  /* ---------- 4d. Geen chatbot op de kinderpagina ---------- */
  (function(){
    var ids = ["kameo-chat-wrapper", "kameo-teaser", "kameo-nudge"];
    function weg(){
      var gevonden = 0;
      ids.forEach(function(id){
        var el = document.getElementById(id);
        if (el && el.parentNode){ el.parentNode.removeChild(el); gevonden++; }
      });
      return gevonden;
    }
    weg();
    if (!("MutationObserver" in window)) return;
    var obs = new MutationObserver(weg);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); weg(); }, 30000);
  })();

  /* ---------- 5. Zachte reveal bij scrollen ---------- */
  if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    var doelen = root.querySelectorAll("#kaartgrid .kaart, .artikel, .cadeau, .viewer, .ouderrust");
    Array.prototype.forEach.call(doelen, function(el){
      el.style.opacity = "0";
      el.style.transform = "translateY(22px)";
      el.style.transition = "opacity .7s cubic-bezier(.2,.7,.2,1), transform .7s cubic-bezier(.2,.7,.2,1)";
    });
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          en.target.style.opacity = "1";
          en.target.style.transform = "none";
          obs.unobserve(en.target);
        }
      });
    }, { rootMargin: "0px", threshold: 0 });
    Array.prototype.forEach.call(doelen, function(el){ obs.observe(el); });
  }

})();
